import { render, staticRenderFns } from "./CursosEdit.vue?vue&type=template&id=a867115c&scoped=true"
import script from "./CursosEdit.vue?vue&type=script&lang=js"
export * from "./CursosEdit.vue?vue&type=script&lang=js"
import style0 from "./CursosEdit.vue?vue&type=style&index=0&id=a867115c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a867115c",
  null
  
)

export default component.exports